import { Skeleton } from '@doccareplus/ui';

export function NotificationsSkeleton() {
  return (
    <div className="space-y-4" aria-hidden="true">
      {[0, 1, 2].map((row) => (
        <div key={row} className="flex gap-3 border-b border-[var(--border)] pb-4">
          <Skeleton className="h-10 w-10 shrink-0 rounded-[11px]" />
          <div className="flex-1 space-y-2"><Skeleton className="h-4 w-2/5" /><Skeleton className="h-3 w-4/5" /></div>
        </div>
      ))}
    </div>
  );
}
